
import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import EntityMemberCommand from "_shared/entity-members/_api/commands/entity-member-api-command";
import _ from "lodash";
import TeamTemplate from "work/team-templates/team-template";
import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";
import VendorTeamName from "work/work-agreements/teams/vendor-team/vendor-team-name/vendor-team-name";

export default class UpdateTeamTemplateAPIRequest {
  payload: JsonPatchOperation[] = [];

  constructor(originalTemplate: TeamTemplate, updatedTeam: VendorTeam, updatedTeamName: VendorTeamName) {
    if (originalTemplate.name !== updatedTeamName) {
      this.payload.push({
        op: "replace",
        path: "/name",
        value: updatedTeamName.value
      });
    }
    if (
      originalTemplate.leader.userId?.isEqualTo(updatedTeam.leader?.userId)
      && updatedTeam.leader?.legalEntityId
    ) {
      this.payload.push({
        op: "replace",
        path: "/leader",
        value: new EntityMemberCommand(updatedTeam.leader).payload
      });
    }
    if (!_.isEqual(originalTemplate.members.map(member => member.userId), updatedTeam.members.map(member => member.userId))) {
      this.payload.push({
        op: "replace",
        path: "/members",
        value: updatedTeam.members.map(member => new EntityMemberCommand(member).payload)
      });
    }
    if (originalTemplate.marketplaceId?.isEqualTo(updatedTeam.marketplaceId)) {
      this.payload.push({
        op: "replace",
        path: "/marketplaceId",
        value: updatedTeam.marketplaceId?.value
      });
    }
  }
}
